/* eslint-disable react/prefer-es6-class, react/prefer-stateless-function, react/prop-types, react/no-multi-comp */
import classnames from 'classnames';
import React from 'react';

/**
 * These are choices that are specific to the applications. Use common/choices
 * for creating non redundant ones.
 */
export const Stat = React.createClass({
  displayName: 'Stat',

  propTypes: {
    type: React.PropTypes.oneOf([
      'started',
      'new',
      'reviewed',
      'mastered',
      'strong',
      'weak',
      'time',
    ]).isRequired,
  },

  render() {
    return (
      <li className={`stat stat-${this.props.type}`}>
        <div className="accent" />

        <div className="stat-details">{this.props.children}</div>
      </li>
    );
  },
});

export const StatData = React.createClass({
  render() {
    // NOTE: This is used to handle the odd case where the markup is actually
    // embedded in the label. As it stands, this is only from the humanized
    // time method.
    if (!(this.props.children instanceof Array)) {
      return (<div className="primary" dangerouslySetInnerHTML={{ __html: this.props.children }} />);
    }

    return (<div className="primary">{this.props.children}</div>);
  },
});

export const StatLabel = React.createClass({
  displayName: 'StatLabel',

  render() {
    return (<div className="secondary">{this.props.children}</div>);
  },
});

export const Stats = React.createClass({
  displayName: 'Stats',

  propTypes: {
    className: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      className: '',
    };
  },

  render() {
    const className = classnames('stats', this.props.className);
    return (<ul className={className}>{this.props.children}</ul>);
  },
});
